const styles = {
  formHolder: {
    flex: '1'
  },
  previewHolder: {
    width: '124px',
    marginLeft: '20px',
    height: '124px'
  }
}

export default styles
